import { render, staticRenderFns } from "./OtcReminder.vue?vue&type=template&id=407477ae&scoped=true&"
import script from "./OtcReminder.vue?vue&type=script&lang=js&"
export * from "./OtcReminder.vue?vue&type=script&lang=js&"
import style0 from "./OtcReminder.vue?vue&type=style&index=0&id=407477ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407477ae",
  null
  
)

export default component.exports